const wix = (id, w = 1200, h = 900) =>
  `https://static.wixstatic.com/media/${id}/v1/fill/w_${w},h_${h},al_c,q_90,enc_avif/fg.jpg`;

export const SERVICES = [
  {
    slug: "glass-pool-fencing-sydney",
    name: "Glass Pool Fencing",
    badge: "Flagship service",
    title: "Glass Pool Fencing Sydney",
    seoTitle: "Frameless Glass Pool Fencing Sydney | Pool Fence Installers | Fusion Glass",
    metaDescription: "Frameless & semi-frameless glass pool fencing across Sydney. Toughened safety glass, made-to-measure panels and fast replacement. Free on-site quotes.",
    tagline: "Frameless views, compliant safety.",
    image: wix("cd8454_776d335be41544189fb0fc702d025f2d~mv2.jpg"),
    alt: "Glass Pool Fencing Sydney, Glass Pool Fencing Replacement, New Home Glass Pool Fencing",
    intro: [
      "A glass pool fence keeps your pool area safe without hiding it. Fusion Glass designs, supplies and installs frameless and semi-frameless glass pool fencing across Sydney - toughened safety glass, quality spigots and clean lines that let your pool and garden take centre stage.",
      "Whether you are building new, renovating, or need a damaged panel replaced fast, every fence is made to measure and installed to comply with Australian Standard AS 1288.",
    ],
    features: [
      "Frameless and semi-frameless pool fencing systems",
      "Toughened safety glass panels, made to measure",
      "New installations and fast replacement panels",
      "Australian-made glass recommended wherever possible",
      "Made-to-measure for any pool layout or shape",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you replace a single broken pool fence panel?",
        a: "Yes. We offer same-day glass replacement across Sydney wherever possible, and we will always confirm a clear time frame with you before we come out.",
      },
      {
        q: "Will my glass pool fencing comply with pool safety rules?",
        a: "Every fence we install meets Australian Standard AS 1288 and the latest safety and quality standards. We will walk you through exactly what your pool needs at your free quote.",
      },
      {
        q: "How much does glass pool fencing cost?",
        a: "Every pool is different, so we provide free, no-obligation on-site quotes. You will have an exact price for your layout before any work begins.",
      },
    ],
  },
  {
    slug: "frameless-glass-balustrades-sydney",
    name: "Glass Balustrades",
    badge: "Balconies & decks",
    title: "Frameless Glass Balustrades Sydney",
    seoTitle: "Frameless Glass Balustrade Sydney | Balcony & Stair Glass | Fusion Glass",
    metaDescription: "Frameless glass balustrades for Sydney balconies, decks and stairways. Made-to-measure, AS 1288 compliant, with replacement panels available fast.",
    tagline: "Safety that disappears into the view.",
    image: "/uploads/balustrades/photo_20.jpg",
    imagePosition: "18% center",
    alt: "Frameless Glass Balustrade Sydney, Frameless Glass Balustrade Replacement, New Home Frameless Glass Balustrade",
    projects: [
      {
        title: "Tinted glass balustrade - McDonald's Headquarters, Thornleigh",
        description:
          "A yellow-tinted laminated glass balustrade with black standoffs and top rail, installed across the mezzanine and stairs of the McDonald's Headquarters office fit-out in Thornleigh. Posts welded on site and set to line. Drag the slider to see the job from during works to finished.",
        beforeAfter: {
          before: "/uploads/balustrades/photo_3.jpg",
          after: "/uploads/balustrades/photo_5.jpg",
          label: "Drag to compare - during works vs finished",
        },
        photos: [
          { src: "/uploads/balustrades/photo_1.jpg", caption: "Site set up, scaffold ready for the install" },
          { src: "/uploads/balustrades/photo_2.jpg", caption: "Posts welded on site, set to a line" },
          { src: "/uploads/balustrades/photo_4.jpg", caption: "Tinted glass with black top rail along the stairs" },
        ],
      },
      {
        title: "Rooftop glass balustrade, Sydney CBD",
        description:
          "Frameless glass balustrade with a sleek metal top rail around a CBD rooftop terrace and walkway - unobstructed city views with full edge protection. Drag the slider to see the rooftop before and after.",
        beforeAfter: {
          before: "/uploads/balustrades/photo_6.jpg",
          after: "/uploads/balustrades/photo_7.jpg",
          label: "Drag to compare - before vs finished",
        },
        photos: [
          { src: "/uploads/balustrades/photo_8.jpg", caption: "Glass panels with posts along the rooftop walkway" },
          { src: "/uploads/balustrades/photo_9.jpg", caption: "Curved handrail detail beside the rooftop garden" },
        ],
      },
      {
        title: "Whale Beach house - frameless glass, ocean views",
        description:
          "Frameless glass balustrades across the balconies, rooftop terrace and stairs of a beachfront home at Whale Beach - every panel craned in and every view kept clear. Drag the slider to see the job from works to finished.",
        beforeAfter: {
          before: "/uploads/balustrades/photo_10.jpg",
          after: "/uploads/balustrades/photo_11.jpg",
          label: "Drag to compare - during works vs finished",
        },
        photos: [
          { src: "/uploads/balustrades/photo_12.jpg", caption: "Polished steel handrail over frameless glass" },
          { src: "/uploads/balustrades/photo_13.jpg", caption: "Glass balconies with a tilting weather screen" },
          { src: "/uploads/balustrades/photo_14.jpg", caption: "Glass and steel handrails through the stairwell" },
          { src: "/uploads/balustrades/photo_16.jpg", caption: "Stepped frameless glass with polished handrail on the timber garden stairs" },
          { src: "/uploads/balustrades/photo_15.jpg", caption: "Standoff-mounted glass along the spa terrace, looking back over Whale Beach" },
        ],
      },
      {
        title: "Harbourfront terrace - frameless glass, Rozelle",
        description:
          "Fully frameless glass balustrade on black spigots around the terrace of a waterfront home at Rozelle, with glass pool fencing below. No posts, no top rail - just uninterrupted views across the bay to the Harbour Bridge and city skyline.",
        photos: [
          { src: "/uploads/balustrades/photo_20.jpg", wide: true, caption: "Frameless glass on black spigots - clear views across the water to the Harbour Bridge and CBD" },
          { src: "/uploads/balustrades/photo_17.jpg", caption: "The view from inside - glass balustrade framing the harbour at dusk" },
          { src: "/uploads/balustrades/photo_18.jpg", caption: "Spigot-fixed glass around the terrace, pool fencing below" },
          { src: "/uploads/balustrades/photo_19.jpg", caption: "Low-profile spigots along the balcony edge above the pool" },
        ],
      },
    ],
    intro: [
      "Frameless glass balustrades give balconies, decks and stairways full protection with none of the visual clutter. Fusion Glass engineers and installs glass balustrades across Sydney for new homes, renovations and commercial projects.",
      "Every balustrade is made to measure, installed to comply with Australian Standard AS 1288, and backed by our workmanship guarantee.",
    ],
    features: [
      "Balcony, deck and stairway balustrades",
      "New home and replacement installations",
      "Toughened safety glass, made to measure",
      "Compliant with Australian Standard AS 1288",
      "Suits residential and commercial projects",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Do you replace existing balustrade glass?",
        a: "Yes. We replace damaged or non-compliant balustrade panels and can match your existing hardware wherever possible.",
      },
      {
        q: "Can you work with my builder or architect?",
        a: "Absolutely. We regularly work with builders, home renovators, interior designers and architects on residential and commercial projects across Sydney.",
      },
      {
        q: "How long does a balustrade install take?",
        a: "After your free on-site quote and a made-to-measure manufacture, most installations are completed within a day. We will confirm timing before we start.",
      },
    ],
  },
  {
    slug: "glass-grab-rails-sydney",
    name: "Glass Stair Balustrades",
    badge: "Stairs",
    title: "Glass Stair Balustrades & Stair Rails Sydney",
    seoTitle: "Glass Stair Balustrade Sydney | Curved & Frameless Stair Rails | Fusion Glass",
    metaDescription: "Curved and standard glass stair rails in Sydney. Frameless glass stair balustrades, low iron (Sapphire) glass and matching handrails - templated, made and fitted by our own team.",
    tagline: "Curved or straight - glass that follows every step.",
    image: "/uploads/grabrails/photo_19.jpg",
    alt: "Frameless Glass Grab Rails for Stairs Sydney, Frameless Glass Grab Rails Replacement, New Home Frameless Glass Grab Rails",
    projects: [
      {
        title: "Curved stepped glass with lift access doors - East Ryde",
        description:
          "A one-off curved glass balustrade for a winding staircase at East Ryde. The panel was templated to the curve of the stair and cut out around every step so the glass follows the treads exactly, with a matching curved panel on the landing and two frameless glass doors on black posts giving access to the home lift. All toughened, polished and fitted on black mini posts and spigots to tie in with the pale timber. Drag the slider to see the stair before and after.",
        beforeAfter: {
          before: "/uploads/grabrails/photo_25.jpg",
          after: "/uploads/grabrails/photo_27.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished curved glass",
        },
        photos: [
          { src: "/uploads/grabrails/photo_26.jpg", caption: "Landing view - the two glass access doors to the lift and the curved panel dropping down the stair" },
        ],
      },
      {
        title: "Curved low iron (Sapphire) glass stair balustrade - waterfront home, Tennyson Point",
        description:
          "Curved frameless glass for a sculptural staircase at a waterfront home in Tennyson Point. The low iron Sapphire glass was bent to follow the sweep of the stair and fitted frameless to the treads, so it reads crystal clear with no green tint against the white render and oak. We also fabricated the matching curved stainless steel handrail with integrated LED lighting - see the Stainless Steel page for the handrail detail. Drag the slider to see the stair with the builder's temporary rail vs the finished curved glass.",
        beforeAfter: {
          before: "/uploads/stainless/tp2.jpg",
          after: "/uploads/stainless/tp3.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - temporary rail vs finished curved glass",
        },
        photos: [
          { src: "/uploads/stainless/tp4.jpg", caption: "Curved Sapphire glass on standoffs, LED handrail lit at dusk, harbour beyond" },
          { src: "/uploads/stainless/tp1.jpg", caption: "Curved Sapphire glass and handrail following the stair, water views beyond" },
        ],
      },
      {
        title: "Low iron (Sapphire) glass stair balustrade - Kirribilli",
        description:
          "A frameless low iron Sapphire glass balustrade for a renovated staircase in Kirribilli. Sapphire low iron glass removes the green tint of standard glass, so the panels read crystal clear against the white walls and oak treads. Side-fixed with brushed stainless standoffs and matched with a continuous stainless wall grab rail - the stair's LED step lighting now shows straight through the glass. Drag the slider to see the stair before and after.",
        beforeAfter: {
          before: "/uploads/grabrails/photo_1.jpg",
          after: "/uploads/grabrails/photo_2.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished",
        },
        photos: [
          { src: "/uploads/grabrails/photo_3.jpg", caption: "Sapphire low iron glass with standoff fixings - crystal clear, no green edge, LED treads showing through" },
        ],
      },
      {
        title: "Channel base low iron (Sapphire) glass balustrade - Kellyville",
        description:
          "A fully frameless channel base balustrade for a new two-storey home in Kellyville. Sapphire low iron glass panels sit in a concealed base channel along the stair stringer and upper landing - no posts, no clamps, no visible fixings - so the glass disappears against the white walls and timber treads and the whole stairwell reads as one open space. Drag the slider to see the stair before and after.",
        beforeAfter: {
          before: "/uploads/grabrails/photo_4.jpg",
          after: "/uploads/grabrails/photo_5.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished",
        },
        photos: [
          { src: "/uploads/grabrails/photo_6.jpg", caption: "Looking down the stairwell - channel-set glass on both flights, no visible fixings" },
          { src: "/uploads/grabrails/photo_7.jpg", caption: "Sapphire glass along the upper landing, clear sightlines through to the dining room" },
        ],
      },
      {
        title: "Clear glass stair balustrade replacement - Leichhardt",
        description:
          "Replacing a dated timber-and-wrought-iron balustrade with frameless clear glass on the stair and upper landing of a Leichhardt home. The old posts, handrail and twisted iron balusters were removed and new toughened clear glass panels fitted on brushed stainless standoffs - opening the stairwell up to the skylight and glass-block wall and letting the artwork below show straight through. Drag each slider to see the old balustrade vs the finished glass.",
        beforeAfter: [
          {
            before: "/uploads/grabrails/photo_12.jpg",
            after: "/uploads/grabrails/photo_11.jpg",
            beforeLabel: "Before",
            label: "Stair - drag to compare old iron vs new glass",
          },
          {
            before: "/uploads/grabrails/photo_14.jpg",
            after: "/uploads/grabrails/photo_9.jpg",
            beforeLabel: "Before",
            label: "Looking down - drag to compare before vs finished",
          },
          {
            before: "/uploads/grabrails/photo_13.jpg",
            after: "/uploads/grabrails/photo_8.jpg",
            beforeLabel: "Before",
            label: "Upper landing - drag to compare before vs finished",
          },
        ],
        photos: [
          { src: "/uploads/grabrails/photo_10.jpg", caption: "Standoff-fixed clear glass following the stair, artwork visible straight through" },
        ],
      },
      {
        title: "New staircase glass with welded top rail - Strathfield",
        description:
          "A complete glass balustrade for a new floating-tread staircase in Strathfield. Toughened clear glass panels fixed with round spigots, capped with a square top rail welded on site and powder coated in satin Monument to match the steel stringer. Every panel was scribed to follow the treads with no gaps between the glass and the tread - a clean, continuous line from the ground floor to the upper landing. Drag the slider to see the stair from bare steel to finished.",
        beforeAfter: [
          {
            before: "/uploads/grabrails/photo_16.jpg",
            after: "/uploads/grabrails/photo_18.jpg",
            beforeLabel: "Before",
            label: "Stair - drag to compare bare stringer vs finished glass",
          },
          {
            before: "/uploads/grabrails/photo_15.jpg",
            after: "/uploads/grabrails/photo_22.jpg",
            beforeLabel: "Before",
            label: "Upper landing - drag to compare site rail vs finished glass",
          },
        ],
        photos: [
          { src: "/uploads/grabrails/photo_17.jpg", caption: "Our team lifting the stair panels into place on vacuum cups" },
          { src: "/uploads/grabrails/photo_19.jpg", caption: "Round spigots, satin Monument welded top rail and glass sitting tight to every tread" },
          { src: "/uploads/grabrails/photo_21.jpg", caption: "Satin Monument round spigots on the oak nosing - detail of the void balustrade" },
          { src: "/uploads/grabrails/photo_20.jpg", caption: "Looking down the stair - glass scribed to the treads with no gaps" },
          { src: "/uploads/grabrails/photo_23.jpg", caption: "Welded square top rail returning around the upper landing to the wall handrail" },
          { src: "/uploads/grabrails/photo_24.jpg", caption: "The void balustrade from below, under the pendant cluster" },
        ],
      },
    ],
    intro: [
      "Curved or straight, a frameless glass stair balustrade opens up a staircase like nothing else - the treads, the light and the room beyond stay in full view, with a secure rail where you need it. We make both: standard straight-run glass stair rails and true curved glass, bent to follow the sweep of the stair and cut out around every step.",
      "Fusion Glass templates, manufactures and installs glass stair balustrades across Sydney - clear toughened glass or low iron (Sapphire) glass with no green tint, on spigots, standoffs or a concealed channel base, with matching stainless steel or powder coated handrails fabricated in-house. Every installation is compliant with Australian Standard AS 1288.",
    ],
    features: [
      "Curved glass stair rails - bent and stepped to follow the stair",
      "Standard frameless glass stair balustrades on spigots or standoffs",
      "Low iron (Sapphire) glass for a crystal-clear, tint-free finish",
      "Channel base systems with no visible fixings",
      "Matching stainless steel, LED and powder coated handrails",
      "Replacement of timber, wrought iron or dated balustrades",
      "Compliant with Australian Standard AS 1288",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you make curved glass for a curved staircase?",
        a: "Yes. We template the stair on site, have the glass bent to the exact radius and cut it to follow each tread - see our East Ryde and Tennyson Point projects above. Curved glass takes longer to manufacture than straight panels, so we confirm lead time at quote stage.",
      },
      {
        q: "What is the difference between low iron (Sapphire) glass and standard glass?",
        a: "Standard clear glass has a slight green tint on the edge and through thick panels. Low iron glass - often sold as Sapphire or Starphire - has that iron removed, so it reads crystal clear against white walls and pale timber. It costs more than standard clear, and we will show you both at your quote.",
      },
      {
        q: "Can you replace my old timber or wrought iron stair balustrade with glass?",
        a: "Yes - this is one of our most common jobs. We remove the old posts and balusters, make good the stringer or landing, and fit new frameless glass on spigots, standoffs or a channel base, with a handrail if your stair needs one.",
      },
      {
        q: "Is a frameless glass stair balustrade strong enough and compliant?",
        a: "Yes. We use toughened or toughened-laminated safety glass with engineered fixings, and every installation meets Australian Standard AS 1288 and the National Construction Code requirements for balustrade height and handrails.",
      },
      {
        q: "Do you service my suburb?",
        a: "We service all of Greater Sydney - from the CBD to Western Sydney, the Northern Beaches, North Shore, Inner West, Eastern Suburbs, Southern Sydney and the Hills District.",
      },
    ],
  },
  {
    slug: "mirror-splashbacks-sydney",
    name: "Mirror Splashbacks",
    badge: "Kitchens & bathrooms",
    title: "Mirror Splashbacks Sydney",
    seoTitle: "Mirror Splashbacks Sydney | Black, Bronze & Smokey Mirror | Fusion Glass",
    metaDescription: "Mirror splashbacks in Sydney - black mirror, bronze mirror and smokey black mirror. Toughened, made-to-measure, installed by expert glaziers.",
    tagline: "Light, space and drama - in one panel.",
    image: wix("cd8454_b58ae8a9d4984c4e97e462adb6587caa~mv2.jpg"),
    alt: "Mirror Splashbacks Sydney, Mirror Splashbacks Replacement, Black Mirror Splashbacks, Bronze Mirror Splashbacks, Smokey Black Mirror Splashbacks",
    intro: [
      "A mirror splashback doubles light and space in any kitchen or bathroom. Choose classic silver, or make a statement with black mirror, bronze mirror or smokey black mirror - all toughened and cut to your exact wall, including around power points and corners.",
      "Fusion Glass supplies, cuts and installs mirror splashbacks across Sydney, with replacements available for damaged or dated splashbacks.",
    ],
    features: [
      "Black, bronze and smokey black mirror splashbacks",
      "Toughened mirror, made-to-measure",
      "Precision cut-outs for power points",
      "Kitchen, bathroom and laundry splashbacks",
      "Replacement splashbacks available",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Which mirror finish should I choose?",
        a: "Black mirror adds drama and depth, bronze mirror warms timber and neutral palettes, and smokey black sits between the two. We bring samples to your free quote so you can see each finish in your own light.",
      },
      {
        q: "Are mirror splashbacks heat resistant?",
        a: "Toughened mirror splashbacks are designed for kitchen and bathroom conditions. We will recommend the right glass for your cooktop and wall setup.",
      },
      {
        q: "Can you match an existing splashback?",
        a: "In most cases, yes. Send us a photo or book a free quote and we will advise on the closest match.",
      },
    ],
  },
  {
    slug: "custom-mirror-installation-sydney",
    name: "Custom Mirrors",
    badge: "Gyms & wardrobes",
    title: "Custom Mirror Installation Sydney",
    seoTitle: "Custom Mirror Installation Sydney | Wall, Gym & Shaped Mirrors | Fusion Glass",
    metaDescription: "Custom mirror installation across Sydney - gym mirrors, wall mirrors, cabinet mirror replacement, bronze, black and smokey black mirrors. Free quotes.",
    tagline: "Every wall, every finish, made to fit.",
    image: "/uploads/mirrors/photo_21.jpg",
    alt: "Custom Mirror Installation Sydney, Mirror Replacement, Gym Mirror Installation, Cabinet Mirror Replacement, Bronze Mirror, Black Mirror, Smokey Black Mirror",
    projects: [
      {
        title: "Oversized shaped wall mirror - Kirribilli",
        description:
          "A single oversized mirror - 1400mm wide by 2650mm high - cut to follow the raked gable wall of a Kirribilli home, with two cut-outs to suit the wall's recessed fittings. Templated on site, cut in our factory and lifted into place with a vacuum lifter - the finished mirror doubles the room and reflects the Harbour Bridge and Opera House straight back inside. Drag the slider to see the wall before and after.",
        beforeAfter: {
          before: "/uploads/mirrors/photo_2.jpg",
          after: "/uploads/mirrors/photo_5.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished",
        },
        photos: [
          { src: "/uploads/mirrors/photo_1.jpg", caption: "The finished mirror catching the Opera House from the terrace doors" },
          { src: "/uploads/mirrors/photo_6.jpg", caption: "Mirrored wall and polished stainless trims reflecting the Harbour Bridge" },
          { src: "/uploads/mirrors/photo_3.jpg", caption: "The 1400mm x 2650mm shaped mirror panel cut to template, with both cut-outs, ready to leave the factory" },
          { src: "/uploads/mirrors/photo_4.jpg", caption: "Our team loading the mirror with a vacuum lifter for safe transport" },
        ],
      },
      {
        title: "Retail mirror replacement - Macarthur Square Shopping Centre",
        description:
          "Replacement of the large feature mirror panels behind the TRND signage at Macarthur Square Shopping Centre. New mirror cut to size and fitted into the existing stainless steel frame around the store's signage lettering, with the shopfront back to spotless before trading.",
        photos: [
          { src: "/uploads/mirrors/photo_8.jpg", caption: "The finished shopfront - new mirror panels set behind the TRND lettering" },
          { src: "/uploads/mirrors/photo_7.jpg", caption: "Close-up of the replacement mirror fitted into the existing stainless frame" },
        ],
      },
      {
        title: "Gym mirror installation - fight gym, Leichhardt Shopping Centre",
        description:
          "New full-length gym mirrors for a boxing and fight gym at Leichhardt Shopping Centre. A run of large mirror panels fixed to the main training wall above the padded skirting, giving fighters a clear full view of the ring, bags and floor. Drag the slider to see the wall before and after.",
        beforeAfter: {
          before: "/uploads/mirrors/photo_11.jpg",
          after: "/uploads/mirrors/photo_10.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished",
        },
        photos: [
          { src: "/uploads/mirrors/photo_9.jpg", caption: "The finished run of mirrors reflecting the ring and heavy bags" },
        ],
      },
      {
        title: "Gym mirror replacement - Marrickville",
        description:
          "A shattered mirror panel on the main training wall of a Marrickville gym, made safe and replaced. We removed the damaged panel, cleared the wall and fitted a new made-to-measure mirror on polished standoffs to match the existing panels - back in use the same day. Drag the slider to see the shattered mirror vs the replacement.",
        beforeAfter: {
          before: "/uploads/mirrors/photo_14.jpg",
          after: "/uploads/mirrors/photo_12.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - shattered vs replaced",
        },
        photos: [
          { src: "/uploads/mirrors/photo_13.jpg", caption: "Damaged panel removed and the wall cleared, ready for the new mirror" },
        ],
      },
      {
        title: "Home gym mirror installation - Chatswood",
        description:
          "Two custom mirrors for a garage home gym in Chatswood. A made-to-measure panel fitted neatly between the fold-back Rogue rack brackets so the rack still folds flat against the wall, plus a full-height mirror along the hallway wall to open up the training space. Drag each slider to see the walls before and after.",
        beforeAfter: [
          {
            before: "/uploads/mirrors/photo_18.jpg",
            after: "/uploads/mirrors/photo_17.jpg",
            beforeLabel: "Before",
            label: "Rack wall - drag to compare before vs finished",
          },
          {
            before: "/uploads/mirrors/photo_15.jpg",
            after: "/uploads/mirrors/photo_16.jpg",
            beforeLabel: "Before",
            label: "Hallway wall - drag to compare before vs finished",
          },
        ],
        photos: [],
      },
      {
        title: "Radius arch mirrors - barber shop, Auburn",
        description:
          "Three made-to-measure radius mirrors for a new barber shop fit-out in Auburn. Each mirror was templated to the curved arch of its LED-lit recess and cut with a polished radius top so it sits flush inside the lighting halo above the vanity. Drag the slider to see the stations before and after the mirrors went in.",
        beforeAfter: {
          before: "/uploads/mirrors/photo_20.jpg",
          after: "/uploads/mirrors/photo_19.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - before vs finished",
        },
        photos: [],
      },
      {
        title: "Bevelled edge feature mirror replacement - Turramurra",
        description:
          "Replacing a dated feature mirror in the wall panelling of a Turramurra entry hall. We removed the old mirror and adhesive, prepared and patched the wall, then fitted new bevelled edge mirror panels - a grid of five with a mitred top row, each panel finished with a polished bevelled edge - set precisely within the existing moulding. Drag the slider to see the wall before and after.",
        beforeAfter: {
          before: "/uploads/mirrors/photo_25.jpg",
          after: "/uploads/mirrors/photo_22.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - old mirror removed vs finished",
        },
        photos: [
          { src: "/uploads/mirrors/photo_24.jpg", caption: "Wall patched and prepared, fixing points marked for the new panels" },
          { src: "/uploads/mirrors/photo_21.jpg", caption: "Bevelled edge panels reflecting the staircase and formal lounge" },
          { src: "/uploads/mirrors/photo_23.jpg", caption: "The new feature mirror seen from the front entry" },
        ],
        video: { src: "/uploads/mirrors/video_1.mp4", poster: "/uploads/mirrors/poster_1.jpg", caption: "Walk past the finished bevelled edge feature mirror - the panel joins and polished bevels catch the light" },
      },
    ],
    intro: [
      "From full-height gym mirrors to wardrobe doors and custom wall mirrors, Fusion Glass measures, supplies and installs custom mirrors across Sydney in every finish - clear, bronze, black and smokey black.",
      "We also replace cracked or dated mirrors, including built-in cabinet mirror replacements.",
    ],
    features: [
      "Gym mirror installation",
      "Custom wall mirrors, any size",
      "Cabinet mirror replacement",
      "Mirror replacement for damaged panels",
      "Bronze, black and smokey black finishes",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Do you install gym mirrors at home?",
        a: "Yes - home gyms are one of our most common custom mirror jobs. We fix mirrors safely to your wall with the right fixings for your gym layout.",
      },
      {
        q: "Can you replace a mirror inside a built-in wardrobe?",
        a: "Yes. Cabinet mirror replacement is a quick job for our glaziers - we match the size and finish of your existing panel.",
      },
      {
        q: "How do I get a price?",
        a: "Request a free quote online or call us. For straightforward jobs we can often quote from a few measurements and photos.",
      },
    ],
  },
  {
    slug: "custom-shower-screens-sydney",
    name: "Shower Screens",
    badge: "Made to measure",
    title: "Custom Shower Screens Sydney",
    seoTitle: "Frameless Shower Screens Sydney | Custom & Corner Screens | Fusion Glass",
    metaDescription: "Custom shower screens in Sydney - frameless, semi-frameless and corner-shaped screens. Made-to-measure installs and fast shower screen replacement.",
    tagline: "A perfect fit for every bathroom.",
    image: wix("cd8454_39a7d16294914b72a3317b814250ed17~mv2.jpg"),
    alt: "Custom Shower Screens Sydney, Shower Screens Installation, Corner Shaped Shower Screen, Shower Screen Replacement",
    intro: [
      "A custom shower screen turns a tired bathroom into a finished one. Fusion Glass measures, manufactures and installs frameless and semi-frameless shower screens across Sydney - including corner-shaped screens for tricky layouts.",
      "Renovating or replacing a broken screen? We handle new installations and replacements, all made to measure and guaranteed.",
    ],
    features: [
      "Frameless and semi-frameless shower screens",
      "Corner-shaped screens for tricky layouts",
      "New installations and replacements",
      "Toughened safety glass, made to measure",
      "Precision hardware in quality finishes",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you fit a screen to a non-standard shower?",
        a: "Yes - that is exactly what custom means. We measure on site and manufacture to your exact dimensions, including corner and angled layouts.",
      },
      {
        q: "Do you replace old or broken shower screens?",
        a: "Yes. We remove old screens, supply replacements, and can often complete the swap quickly. Book a free quote to get started.",
      },
      {
        q: "What glass do you use?",
        a: "Toughened safety glass that meets Australian Standard AS 1288, with hardware to suit your bathroom's finish.",
      },
    ],
  },
  {
    slug: "glass-replacement-sydney",
    name: "Glass Replacement",
    badge: "Same-day & 24/7",
    title: "Glass Replacement Sydney | Emergency Glazing",
    seoTitle: "Glass Replacement Sydney | Emergency Glazier 24/7 | Fusion Glass",
    metaDescription: "Glass replacement in Sydney with same-day service. Door, window, shop front, school and sliding door glass - 24/7 emergency glazing on call.",
    tagline: "Cracked glass? We will be there today.",
    image: "/uploads/replacement/photo_19.jpg",
    alt: "Glass Replacement Sydney, Door Glass Replacement, Window Glass Replacement, Shop Front Glass Replacement, School Glass Replacement, Aged Care Glass Replacement, Sliding Door Glass Replacement, Emergency Glass Replacement, Glazing Sydney",
    projects: [
      {
        title: "Shattered balustrade panel replacement - Mascot",
        description:
          "A toughened glass balustrade panel shattered on the upstairs landing of a Mascot home. We made the area safe, removed the broken panel from its stainless steel spigots and top rail, and fitted a new made-to-measure toughened panel to match the existing run. Drag the slider to see the shattered panel vs the replacement.",
        beforeAfter: {
          before: "/uploads/replacement/photo_1.jpg",
          after: "/uploads/replacement/photo_2.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - shattered vs replaced",
        },
        photos: [],
      },
      {
        title: "Shop front glass replacement - Coogee",
        description:
          "A large single-pane shop front window replaced for a retail premises on the main strip at Coogee. The old glass was removed, the frame cleaned and re-glazed with a new oversized toughened safety glass panel - secure, clear and ready for the new tenant's fit-out. Drag the slider to see the empty frame vs the new glass.",
        beforeAfter: {
          before: "/uploads/replacement/photo_3.jpg",
          after: "/uploads/replacement/photo_4.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - empty frame vs new glass",
        },
        photos: [],
      },
      {
        title: "Front door glass replacement - Glenhaven",
        description:
          "The full-height glass panel in a black-framed pivot entry door shattered at a Glenhaven home. We removed the crazed toughened glass from the frame, cleaned up the rebates and re-glazed the door with a new toughened safety glass panel - clear sightlines straight through the entry hall again, with the door back in service the same day. Drag the slider to see the shattered door vs the replacement.",
        beforeAfter: {
          before: "/uploads/replacement/photo_6.jpg",
          after: "/uploads/replacement/photo_5.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - shattered vs replaced",
        },
        photos: [],
      },
      {
        title: "Crane-lift window glass replacement - Palm Beach",
        description:
          "An oversized fixed window panel replaced at a two-storey beach house in Palm Beach. With no access from the street, the new glass was lifted over the roof by crane on a vacuum lifter and guided into the opening by our team - a clean re-glaze with uninterrupted views back out to the ocean. Drag the slider to see the empty opening vs the new glass.",
        beforeAfter: {
          before: "/uploads/replacement/photo_9.jpg",
          after: "/uploads/replacement/photo_10.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - empty opening vs new glass",
        },
        photos: [
          { src: "/uploads/replacement/photo_8.jpg", caption: "Crane set up to swing the new panel over the roof from the street" },
          { src: "/uploads/replacement/photo_7.jpg", caption: "The oversized glass panel airborne on the vacuum lifter, tag lines keeping it steady" },
        ],
      },
      {
        title: "Bifold door double glazed glass replacement - Lidcombe",
        description:
          "A shattered double glazed panel in an upstairs aluminium bifold door at Lidcombe. We made the opening safe and weather-tight with a temporary board, had a new double glazed unit manufactured to match the existing panels, then re-glazed the door leaf - full insulation and clear sightlines restored. Drag the slider to see the shattered panel vs the finished door.",
        beforeAfter: {
          before: "/uploads/replacement/photo_11.jpg",
          after: "/uploads/replacement/photo_13.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - shattered vs replaced",
        },
        photos: [
          { src: "/uploads/replacement/photo_12.jpg", caption: "Temporary board fitted to keep the room secure while the new double glazed unit was made" },
        ],
      },
      {
        title: "Round porthole window glass replacement - Chatswood",
        description:
          "A cracked pane in a brass-framed circular porthole window set into the brick stairwell of a Chatswood home. We templated the opening on site, cut a new circular panel to the exact diameter in our factory and re-glazed the round frame - a shape most glaziers won't touch, handled in-house by our own team.",
        photos: [
          { src: "/uploads/replacement/photo_15.jpg", caption: "The cracked pane in the brass-framed round window before replacement" },
          { src: "/uploads/replacement/photo_14.jpg", caption: "New circular glass cut to template in our factory, ready to fit" },
        ],
      },
      {
        title: "School window glass replacement - Homebush",
        description:
          "A cracked, taped-up lower window pane in a classroom at a Homebush school. We removed the damaged glass from the aluminium frame and re-glazed it with new Grade A safety glass to suit the school environment - done outside class time with the room back in use straight away. Drag the slider to see the cracked pane vs the replacement.",
        beforeAfter: {
          before: "/uploads/replacement/photo_16.jpg",
          after: "/uploads/replacement/photo_17.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - cracked vs replaced",
        },
        photos: [],
      },
      {
        title: "Tinted commercial window glass replacement - Silverwater",
        description:
          "A broken tinted panel on the first floor of a commercial building in Silverwater. We removed the damaged pane from the curtain-wall frame and re-glazed it with a matching dark tinted glass so the new panel blends seamlessly into the reflective facade - no mismatched shade, no scaffold, done from our glass truck. Drag the slider to see the empty opening vs the finished facade.",
        beforeAfter: {
          before: "/uploads/replacement/photo_18.jpg",
          after: "/uploads/replacement/photo_19.jpg",
          beforeLabel: "During works",
          label: "Drag to compare - during works vs finished",
        },
        photos: [],
      },
      {
        title: "High performance glass replacement - Rozelle",
        description:
          "A cracked floor-to-ceiling panel in a black-framed sliding door at a Rozelle apartment. We replaced it with matching high performance low-E glass so the new panel keeps the same energy rating and clarity as the rest of the facade - full harbour views restored without compromising the building's thermal performance. Drag the slider to see the cracked panel vs the finished door.",
        beforeAfter: {
          before: "/uploads/replacement/photo_20.jpg",
          after: "/uploads/replacement/photo_21.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - cracked vs replaced",
        },
        photos: [],
      },
    ],
    intro: [
      "Broken glass at your home, office, shop or school? We provide same-day service and same-day replacement - and we actually answer your calls, 24/7 for emergencies.",
      "Fusion Glass replaces door glass, window glass, shop front glass, school glass, aged care glass and sliding door glass across Sydney. When we say we are coming, we will be there.",
    ],
    features: [
      "Same-day service and same-day replacement",
      "24/7 calls for emergency glass",
      "Door, window and sliding door glass",
      "Shop front and commercial glass",
      "School and aged care glass replacement",
      "On-site replacement service - we come to you",
    ],
    faqs: [
      {
        q: "Do you offer emergency glass replacement in Sydney?",
        a: "Yes. Our emergency line takes calls 24/7, and we provide same-day service and same-day replacement wherever possible.",
      },
      {
        q: "Can you replace shop front glass after hours?",
        a: "We take emergency calls 24/7 and will make your premises secure and replace the glass as quickly as possible.",
      },
      {
        q: "Which areas do you cover?",
        a: "All of Greater Sydney - Western Sydney, Inner West, Eastern Suburbs, Northern Beaches, Southern Sydney, North Shore, Hills District and the CBD.",
      },
    ],
  },
  {
    slug: "frameless-glass-doors-sydney",
    name: "Glass Doors",
    badge: "Hinged & fluted",
    title: "Frameless Glass Doors Sydney",
    seoTitle: "Frameless Glass Doors Sydney | Stylish, Fluted & Hinged | Fusion Glass",
    metaDescription: "Frameless glass doors in Sydney - stylish, fluted and hinged glass doors, made to measure and professionally installed. Free on-site quotes.",
    tagline: "Doors you can see straight through.",
    image: wix("cd8454_6b91ac7f568c4975b04d72fb48c80efa~mv2.jpg"),
    alt: "Frameless Glass Doors Sydney, Stylish Glass Doors, Fluted Glass Doors, Hinged Glass Doors",
    projects: [
      {
        title: "Fluted glass hinged door to a side passage - Chester Hill",
        description:
          "A frameless fluted (reeded) glass hinged door closing off the side passage of a new home in Chester Hill, with white patch fittings, white pull handle and a white top patch lock to disappear against the rendered walls. The fluted glass lets light through while blurring the view, and the door was templated to the opening and fitted in a single visit. Drag the slider to see the open passage before and the finished door after.",
        beforeAfter: {
          before: "/uploads/doors/photo_1.jpg",
          after: "/uploads/doors/photo_2.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - open passage vs fluted glass door",
        },
        photos: [
          { src: "/uploads/doors/photo_3.jpg", caption: "White patch hinges and pull handle on frameless fluted glass - privacy without losing light" },
        ],
        video: { src: "/uploads/doors/video_1.mp4", poster: "/uploads/doors/poster_1.jpg", caption: "Walk-through of the finished fluted glass door, soft-close hinges and white hardware" },
      },
      {
        title: "Frosted sandblast glass toilet door - Oatlands",
        description:
          "A frameless hinged toilet door in 10mm toughened frosted (sandblast) glass for an ensuite in Oatlands. The marble-clad opening was left as a bare doorway, so we templated the glass to the stone reveal and hung it on brushed stainless patch hinges with a matching patch lock. The sandblast finish gives full privacy while still letting light through to the WC. Drag the slider to see the open doorway before and the finished door after.",
        beforeAfter: {
          before: "/uploads/doors/photo_4.jpg",
          after: "/uploads/doors/photo_5.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - open doorway vs frosted glass toilet door",
        },
      },
    ],
    intro: [
      "Frameless glass doors open up interiors while keeping rooms defined. Choose clear, fluted or hinged glass doors - all made to measure and installed by our glaziers.",
      "Perfect for home offices, ensuites, wardrobes and modern room dividers across Sydney.",
    ],
    features: [
      "Stylish frameless glass doors",
      "Fluted glass for privacy with light",
      "Hinged glass doors, made to measure",
      "Home and office applications",
      "Toughened safety glass",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "What is fluted glass?",
        a: "Fluted glass has vertical ribs that blur what is behind it while still letting light through - a popular choice for bathrooms and room dividers.",
      },
      {
        q: "Can you match a glass door to my existing joinery?",
        a: "Yes. We measure precisely and supply hardware to suit your existing finish. Book a free on-site quote.",
      },
      {
        q: "Do glass doors meet safety standards?",
        a: "All our glass and installations comply with Australian Standard AS 1288.",
      },
    ],
  },
  {
    slug: "glass-roofs-sydney",
    name: "Glass Roofs",
    badge: "Frameless & aluminium",
    title: "Glass Roofs Sydney",
    seoTitle: "Glass Roofs Sydney | Frameless & Aluminium Glass Roofs | Fusion Glass",
    metaDescription: "Glass roofs in Sydney - frameless glass roofs and aluminium and glass roofs, supplied and installed by expert glaziers. Free on-site quotes.",
    tagline: "Let the sky in - keep the weather out.",
    image: wix("cd8454_1748016397304db183ba8a9491530c9c~mv2.jpg"),
    alt: "Glass Roof Sydney, Frameless Glass Roofs, Aluminium and Glass Roofs",
    intro: [
      "A glass roof brings natural light into patios, alfresco areas and home extensions without exposing them to the weather. Fusion Glass supplies and installs frameless glass roofs and aluminium and glass roofs across Sydney.",
      "Every roof is engineered for Australian conditions and installed to meet the latest safety standards.",
    ],
    features: [
      "Frameless glass roofs",
      "Aluminium and glass roof systems",
      "Made-to-measure for your space",
      "Engineered for Australian conditions",
      "New builds and renovations",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can a glass roof be added to an existing patio?",
        a: "In most cases, yes. Book a free on-site quote and we will advise the right structure and glass for your space.",
      },
      {
        q: "Frameless or aluminium - which should I choose?",
        a: "Frameless delivers uninterrupted light and a premium look; aluminium and glass systems can span larger areas. We will recommend the best fit at your free quote.",
      },
      {
        q: "Is glass roofing safe?",
        a: "We use safety glass and every installation meets the latest Australian standards, including AS 1288.",
      },
    ],
  },
  {
    slug: "sauna-spa-glass-sydney",
    name: "Sauna & Spa Glass",
    badge: "Wellness",
    title: "Sauna & Spa Glass Sydney",
    seoTitle: "Sauna & Spa Glass Sydney | Installation & Replacement | Fusion Glass",
    metaDescription: "Sauna and spa glass in Sydney - installation, replacement and sauna glass doors. Made-to-measure, professionally installed, free quotes.",
    tagline: "Wellness spaces, sealed in glass.",
    image: wix("cd8454_b8c9967b562b4a47ae495b80ea87acac~mv2.jpg"),
    alt: "Sauna & Spa Glass Sydney, Sauna & Spa Glass Installation, Sauna & Spa Glass Replacement, Sauna & Spa Glass Doors",
    intro: [
      "Sauna and spa enclosures demand glass that handles heat, steam and humidity. Fusion Glass supplies, installs and replaces sauna and spa glass across Sydney, including sauna glass doors.",
      "Every panel is made to measure for your space and installed by experienced glaziers.",
    ],
    features: [
      "Sauna and spa glass installation",
      "Sauna glass doors",
      "Replacement glass for existing enclosures",
      "Glass suited to heat and humidity",
      "Made-to-measure panels",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you replace a cracked sauna door?",
        a: "Yes. We replace sauna and spa glass doors and panels - request a free quote and we will measure and match your enclosure.",
      },
      {
        q: "What glass is used for saunas?",
        a: "We select glass suited to high heat and humidity and install it to meet Australian Standard AS 1288.",
      },
      {
        q: "Do you work with spa builders?",
        a: "Yes - we regularly work with builders, renovators and designers on wellness spaces across Sydney.",
      },
    ],
  },
  {
    slug: "stainless-steel-fabrication-sydney",
    name: "Stainless Steel",
    tileName: "Stainless Steel Handrail Fabrication",
    badge: "Fabrication",
    title: "Stainless Steel Handrails Sydney - Curved & Standard Handrail Fabrication",
    seoTitle: "Stainless Steel Handrails Sydney | Curved & Standard Handrail Fabrication | Fusion Glass",
    metaDescription: "Curved and standard stainless steel handrails fabricated and installed in Sydney. Custom handrails, LED handrails, welded and powder coated top rails, plus commercial stainless steelwork.",
    tagline: "Curved or straight - steel, worked to the millimetre.",
    image: "/uploads/stainless/tp1.jpg",
    alt: "Stainless Steel Fabrication and Installation Sydney, Stainless Steel Handrail Fabrication, Commercial Kitchen Stainless Steel",
    projects: [
      {
        title: "Curved Sapphire glass and LED handrail - waterfront home, Tennyson Point",
        description:
          "A sculptural curved staircase at a waterfront home in Tennyson Point. Fusion Glass supplied and installed the curved low iron Sapphire glass balustrade - bent to follow the sweep of the stair so it reads crystal clear with no green tint - and fabricated the custom curved stainless steel handrail to match, with integrated LED strip lighting running the length of the rail to wash the oak treads at night. Glass, steel and lighting all templated, made and fitted by our own team. Drag the slider to see the stair with the builder's temporary rail vs the finished balustrade.",
        beforeAfter: {
          before: "/uploads/stainless/tp2.jpg",
          after: "/uploads/stainless/tp3.jpg",
          beforeLabel: "Before",
          label: "Drag to compare - temporary rail vs finished glass and handrail",
        },
        photos: [
          { src: "/uploads/stainless/tp4.jpg", caption: "The finished stair at dusk - LED handrail lit, curved Sapphire glass and the water beyond" },
          { src: "/uploads/stainless/tp1.jpg", caption: "The curved handrail sweeping up the sculptural stair, water views beyond" },
        ],
      },
      {
        title: "Curved handrail on a Sydney staircase",
        description:
          "A curved stainless steel handrail fabricated and installed on a Sydney staircase, finished together with a frameless glass balustrade. Drag the slider to see the job from on-site works to the finished result.",
        beforeAfter: {
          before: "/uploads/stainless/photo_2.jpg",
          after: "/uploads/stainless/photo_3.jpg",
          label: "Drag to compare - on site vs finished",
        },
        photos: [
          { src: "/uploads/stainless/photo_4.jpg", caption: "Handrail paired with a frameless glass balustrade" },
          { src: "/uploads/stainless/photo_5.jpg", caption: "Steel and glass, installed as one system" },
          { src: "/uploads/stainless/photo_6.jpg", caption: "Handrail fabricated and welded on site" },
          { src: "/uploads/stainless/photo_7.jpg", caption: "Finished handrail and glass balustrade, stair to mezzanine" },
        ],
      },
      {
        title: "Commercial stair handrails, Sydney",
        description:
          "Stainless steel handrails welded, finished and installed on site for a commercial staircase, paired with a frameless glass balustrade beside the lift lobby.",
        beforeAfter: {
          before: "/uploads/stainless/photo_8.jpg",
          after: "/uploads/stainless/photo_11.jpg",
          label: "Drag to compare - on site vs finished",
        },
        photos: [
          { src: "/uploads/stainless/photo_9.jpg", caption: "Welded joints, ground and polished to a seamless finish" },
          { src: "/uploads/stainless/photo_10.jpg", caption: "Handrail posts finished flush to the tiled floor" },
        ],
      },
    ],
    intro: [
      "Fusion Glass fabricates and installs stainless steel handrails across Sydney - standard straight-run rails and true curved handrails rolled to follow a sweeping staircase, including LED-lit handrails and square top rails welded on site and powder coated to match the steel stringer.",
      "Because we make both the glass and the steel, your handrail and balustrade are templated together and fit each other perfectly. Alongside handrails we fabricate commercial kitchen stainless steel and custom architectural steelwork, all made and installed by our own team.",
    ],
    features: [
      "Curved stainless steel handrails rolled to your staircase",
      "Standard straight-run stainless steel handrails",
      "LED handrails with integrated strip lighting",
      "Square and round top rails - welded, polished or powder coated",
      "Wall-mounted grab rails and continuous stair handrails",
      "Commercial kitchen stainless steel and architectural steelwork",
      "Made to match our glass balustrades and stair rails",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you make a curved handrail for a curved staircase?",
        a: "Yes. We template the stair, roll the stainless steel tube to the exact radius and rise, then fit it on site - see the Tennyson Point project above, where the curved handrail also carries LED lighting. Curved rails take longer to fabricate than straight ones, so we confirm lead time at quote stage.",
      },
      {
        q: "What finishes are available?",
        a: "Brushed (satin) stainless and mirror-polished stainless are the most common. Top rails can also be powder coated in colours such as Monument, black or white to match window frames and stringers.",
      },
      {
        q: "Do you install handrails on existing glass balustrades?",
        a: "Yes - we can add a stainless or powder coated handrail to an existing glass balustrade, or replace a dated rail with a new one.",
      },
      {
        q: "Can you work in commercial kitchens?",
        a: "Yes - we fabricate and install commercial kitchen stainless steel and coordinate directly with builders and shop fitters.",
      },
    ],
  },
  {
    slug: "doggy-doors-sydney",
    name: "Doggy Doors",
    badge: "In glass doors",
    title: "Doggy Doors in Glass Doors Sydney",
    seoTitle: "Doggy Doors in Glass Doors Sydney | Pet Door Glazing | Fusion Glass",
    metaDescription: "Doggy doors installed in glass doors and panels across Sydney. Custom glazed toughened panels, made to measure and professionally fitted.",
    tagline: "A door for every member of the family.",
    image: wix("cd8454_8c55a809e8a1472baec3ecb8b5e82b26~mv2.jpg"),
    alt: "Doggy Doors, Doggy Doors in Glass Doors Sydney",
    intro: [
      "Give your pet their own way in and out. We install doggy doors directly into glass doors and panels across Sydney - the flap is glazed into a custom toughened panel for a clean, secure finish.",
      "No awkward cut timber, no clunky inserts - just a properly glazed pet door that looks like it was always there.",
    ],
    features: [
      "Doggy doors in glass doors and panels",
      "Custom toughened glass panels",
      "Clean, secure, professionally glazed",
      "Sliding and hinged glass doors",
      "Made-to-measure for your door",
      "Workmanship guarantee plus full warranties",
    ],
    faqs: [
      {
        q: "Can you put a doggy door in my glass sliding door?",
        a: "Yes. We manufacture a custom toughened glass panel with the pet door glazed in, then fit it to your existing door.",
      },
      {
        q: "Will it suit large dogs?",
        a: "Pet doors come in a range of sizes. We will measure your pet and door at the free quote to recommend the right size.",
      },
      {
        q: "Is the glass still safe?",
        a: "Yes - the panel is toughened safety glass and meets Australian Standard AS 1288.",
      },
    ],
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
